// 实训中心
import {
  guideStudent01,
  guideStudent02,
  guideStudent03,
  guideStudent04,
  guideStudent05,
  guideStudent06,
  guideStudent07,
  guideStudent08,
  guideStudent09,
  guideStudent10,
  guideStudent11,
} from '@/utils/images.js'

const primaryGuide = [
  {
    id: 'guide-1',
    rightnavs: '实训中心',
    title: '第一步：查看实训任务',
    content: '',
    note: '',
    level: 1,
    children: [
      {
        id: 'guide-1-1',
        level: 2,
        content: '1、点击课程实训，进入课程实训详情页面。',
        note: '',
        imgUrlList: [
          {
            url: guideStudent01,
            label: '',
          },
        ],
      },
      {
        id: 'guide-1-2',
        level: 2,
        content:
          '2、查看未完成的实训任务，找到“未完成”标识的实训项目，点击进入该实训项目页面。',
        note: '',
        imgUrlList: [
          {
            url: guideStudent02,
            label: '',
            display: '',
          },
        ],
      },
      {
        id: 'guide-1-3',
        level: 2,
        content:
          '3、进入实训项目，编程区显示的是项目题面（即需要解答的题目）；在界面右侧分别查看了解任务描述、实训任务书、实训指导书为完成实训任务做准备。',
        note: '',
        imgUrlList: [
          {
            url: guideStudent03,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-2',
    level: 1,
    title: '第二步：项目解法编写',
    content: '',
    note: '',
    children: [
      {
        id: 'guide-2-1',
        level: 2,
        content:
          '1、根据实训任务要求，在左侧积木分类区将功能积木拖拽至编程区，并按一定的编程逻辑拼搭积木，完成项目解法编写。',
        note: '',
        imgUrlList: [
          {
            url: guideStudent04,
            label: '',
            display: '',
          },
        ],
      },
      {
        id: 'guide-2-2',
        level: 2,
        content:
          '2、检查项目程序是否成功运行：点击“运行代码”按钮，运行项目程序；在结果区和绘图区分别返回运行成功结果。',
        note: '',
        imgUrlList: [
          {
            url: guideStudent05,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-3',
    level: 1,
    title: '第三步：保存和提交解法',
    content: '',
    note: '',
    children: [
      {
        id: 'guide-3-1',
        level: 2,
        content:
          '1、点击“保存为解法”按钮，弹出“保存代码成功”，完成项目解法提交。',
        note: '',
        imgUrlList: [
          {
            url: guideStudent06,
            label: '',
            display: '',
          },
        ],
      },
      {
        id: 'guide-3-2',
        level: 2,
        content:
          '2、点击“提交代码”按钮，在实训评分弹框填写对应的评价参数，点击“确定”按钮，完成实训作业的提交。',
        note: '',
        imgUrlList: [
          {
            url: guideStudent07,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-4',
    level: 1,
    title: '第四步：查看评价与题解',
    content: '',
    note: '',
    children: [
      {
        id: 'guide-4-1',
        level: 2,
        content: '1、在课程实训详情页，可查看老师对作业的评分。',
        note: '',
        imgUrlList: [
          {
            url: guideStudent08,
            label: '',
            display: '',
          },
        ],
      },
      {
        id: 'guide-4-2',
        level: 2,
        content:
          '2、进入项目详情页，点击“实训报告”按钮，弹出实训评分弹框，可查看老师评价详情。',
        note: '',
        imgUrlList: [
          {
            url: guideStudent09,
            label: '',
            display: '',
          },
        ],
      },
      {
        id: 'guide-4-3',
        level: 2,
        content:
          '3、查看项目解法：点击切换到“项目解法”栏目，点击“详情”按钮，查看参考项目解法详情。',
        note: '',
        imgUrlList: [
          {
            url: guideStudent10,
            label: '',
            display: '',
          },
        ],
      },
      {
        id: 'guide-4-4',
        level: 2,
        content:
          '4、发布新的项目解法：在编程区编写新的项目解法，保存项目解法，在任务栏点击“发布新的项目解法”，完成新解法发布；在任务栏可查看发布的多种项目解法。',
        note: '',
        imgUrlList: [
          {
            url: guideStudent11,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    level:2,
    footer: '关于实训中心模块的更多功能操作，可查看完整版用户手册了解哦～',
  },
]

//附件
const secodeGuide = []
export default {
  primaryGuide,
  secodeGuide,
}
